export const isIntersectionObserverSupported = () => {
  return (
    __isBrowser__ &&
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  );
};

export const createIntersectionObserver = (rootMargin = '0px 0px 0px 0px') => {
  if (!isIntersectionObserverSupported()) {
    return null;
  }

  let onIntersecting: (entry: IntersectionObserverEntry) => void;
  let onNotIntersecting:
    | ((entry: IntersectionObserverEntry) => void)
    | undefined;
  let fireOnce: boolean;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          onIntersecting(entry);
          if (fireOnce) {
            observer.unobserve(entry.target);
          }
        } else if (onNotIntersecting) {
          onNotIntersecting(entry);
        }
      });
    },
    { rootMargin },
  );

  return {
    observe: (
      element: HTMLElement,
      intersectingCallback: (entry: IntersectionObserverEntry) => void,
      options: {
        onNotIntersecting?: (entry: IntersectionObserverEntry) => void;
        fireOnce?: boolean;
      } = {},
    ) => {
      onIntersecting = intersectingCallback;
      onNotIntersecting = options.onNotIntersecting;
      fireOnce = options.fireOnce ?? true;
      observer.observe(element);
    },

    unobserve: (element: HTMLElement) => {
      observer.unobserve(element);
    },

    disconnect: () => {
      observer.disconnect();
    },
  };
};
